<template>
  <div id="forget_outer" class="container vue_body_min_height">
    <div class="forget-head">
      {{userType == 0 ? '个人用户' : '团体用户'}}
    </div>


      <div class="forget-body">
        <div>
          <span>手机：</span>
          <input type="text" v-model="userPhone" placeholder="请输入手机号">
        </div>
        <div id="slide_verify_outer">
          <span>验证码：</span>
          <slide-verify
            style="margin-top: 20px;"
            :l="60"
            @success="onSuccess"
            v-bind:w="slideVerifyWidth"
            @fail="onFail"
            @refresh="onRefresh"
            :slider-text="slideText"
          ></slide-verify>
        </div>
        <div id="phone_verify">
          <span>手机验证码：</span>
          <input class="phone-text" type="text" v-model="userCode" placeholder="请输入验证码">
          <input v-if="codeSecond <= 0" class="phone-button" type="button" value="获取验证码" @click="codeButtonClicked">
          <input
            v-else
            class="phone-button"
            type="button"
            :value="codeSecond + '秒后重试'"
            disabled
            :style="{backgroundColor: '#ddd', color: '#999'}">
        </div>

        <div style="display: flex;flex-direction: row;align-items: flex-start;" >
          <span>设置密码：</span>
          <div style="width: 70%;max-width: 310px;min-width: 180px;display: inline-block;">
            <input type="password"  v-model="userPwd" style="width: 100%;margin-top: 20px;" placeholder="请输入密码">
            <password-verifiy style="margin-top: 5px;" v-bind:password="userPwd" />
          </div>
        </div>

        <div>
          <span>确认密码：</span>
          <input type="password" v-model="doubleUserPwd" placeholder="请再次输入密码">
        </div>

        <input id="forget_submit_button" type="button" value="提交修改" @click="submitEditing">

      </div>
  </div>
</template>

<script>
import GlobalInstance from '../js/shba';
import PasswordVerifiy from "../components/PasswordVerifiy";

export default {
  name: "ForgetPasswordPage",
  components: {
    PasswordVerifiy,
  },
  data() {
    return {
      title: '忘记密码',
      slideText: '滑动验证',
      userPhone: '',
      picVerifiyCode: 0,
      userCode: '',
      userPwd: '',
      doubleUserPwd: '',
      codeSecond: 0,
      codeTimerFlag: null,
    }
  },
  computed: {
    userType() {
      let userType = this.$route.params.userType;
      if (userType == undefined) {
        userType == 0;
      }
      return userType;
    },
    slideVerifyWidth() {
      const slideWidth = $("body").width();
      let width = Math.round(slideWidth * 0.7);
      const minWidth = 265;
      const maxWidth = 310
      if (width < minWidth) {
        width = minWidth
      }
      if (width > maxWidth) {
        width = maxWidth;
      }
      if (isNaN(width)) {
        width = minWidth
      }
      return  width;
    },
  },
  mounted() {
  },
  methods: {

    onSuccess() {
      this.picVerifiyCode = 1;
    },
    onFail() {
      this.picVerifiyCode = 0;
    },
    onRefresh() {
      this.picVerifiyCode = 0;
    },

    codeButtonClicked() {
      if (this.picVerifiyCode == 0) {
        this.$toast('请先进行滑动验证！');
        return;
      }

      let userPhone = this.userPhone.removeBlanks();
      if (userPhone == '') {
        this.$toast('请输入新手机号！');
        return;
      }
      if (!userPhone.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }
      let _this = this;
      let params = {
        tag: 'forget',
        phoneNumbers: userPhone
      }
      this.$store.state.http.ajax.smsSend(params,function (data) {
        if (data.code == 0) {
          _this.beginCodeTime();
        } else {
          _this.$toast('发送失败！');
        }
      }, function (data) {
        _this.$toast('发送失败，请重试！');
      })

    },

    beginCodeTime() {
      if (this.codeTimerFlag != null) {
        return;
      }
      this.codeSecond = 60;

      let _this = this;
      this.codeTimerFlag = setInterval(function () {
        _this.codeSecond --;
        if (_this.codeSecond <= 0) {
          _this.closeCodeTimer();
        }
      }, 1000);
    },
    closeCodeTimer() {
      if (this.codeTimerFlag != null) {
        clearInterval(this.codeTimerFlag);
        this.codeTimerFlag = null;
        this.codeSecond = 0;
      }
    },

    submitEditing() {
      let phone = this.userPhone.removeBlanks();
      if (phone == '') {
        this.$toast('请输入手机号！');
        return;
      }
      if (!phone.isPhoneNumber()) {
        this.$toast('手机号格式不正确！');
        return;
      }

      let picVerifiyCode = this.picVerifiyCode;
      if (picVerifiyCode == 0) {
        this.$toast('您尚未进行滑动验证！');
        return;
      }

      let veriCode = this.userCode.removeBlanks();
      if (veriCode == '') {
        this.$toast('请输入手机验证码！');
        return;
      }

      let password = this.userPwd.removeBlanks();
      if (password == '') {
        this.$toast('请输入密码');
        return;
      }

      if (password.length < 6) {
        this.$toast('密码不得少于6位！');
        return;
      }

      let doublePwd = this.doubleUserPwd.removeBlanks();
      if (doublePwd == '') {
        this.$toast('请再次确认密码！');
        return;
      }

      if (password != doublePwd) {
        this.$toast('两次密码输入不一致！');
        return;
      }

      let params = {
        password: password,
        mobile: phone,
        verificationCode: veriCode
      }
      let _this = this;
      this.$store.state.http.ajax.userForget(params, function (data) {
        let code = data.code;
        if (code == 0) {
          _this.$toast1('密码修改成功！');
          setTimeout(function () {
            _this.$router.push('/login');
          }, 2000);
        } else {
          _this.$toast('提交失败！');
        }
      }, function (data) {
          _this.$toast('提交失败，请重试！');
      });
    },
  }
}
</script>

<style scoped>
  #forget_outer {
    padding-bottom: 60px;
  }

  .forget-head {
    background-color: #fc1a34;
    margin-top: 50px;
    padding: 6px 30px;
    display: inline-block;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
    font-size: 1.5rem;
    font-weight: bold;
    color: white;

  }

  .forget-body {
    width: 100%;
    border: solid 1px #fc1a34;
    min-height: 300px;
    padding-left: 8px;
    padding-right: 8px;
    padding-top: 10px;
    padding-bottom: 30px;
  }

  #forget_outer .forget-body span {
    font-size: 1rem;
    color: #333;
    width: 85px;
    display: inline-block;
    margin-top: 30px;
  }

  #forget_outer .forget-body input {
    outline: none;
    background-color: #eee;
    border: none;
    border-radius: 20px;
    height: 30px;
    color: #333;
    font-size: 1rem;
    text-indent: 15px;
    width: 60%;
    max-width: 310px;
    min-width: 170px;
  }


  #forget_outer .forget-body slide-verify {
    display: inline-block;
  }

  #forget_outer #slide_verify_outer {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
  }

  #forget_outer .forget-body #phone_verify .phone-text {
    width: 35%;
    max-width: 210px;
    min-width: 100px;
    text-indent: 0;
    text-align: center;
    font-size: 1rem;
  }

  #forget_outer .forget-body #phone_verify .phone-button {
    padding: 5px 0;
    text-align: center;
    color: white;
    background-color: #fc1a34;
    border-radius: 20px;
    width: 78px;
    max-width: inherit;
    min-width: inherit;
    font-size: 12px !important;
    font-weight: bold;
    text-indent: 0;
  }

  #forget_outer .forget-body #forget_submit_button {
    background-color: #fc1a34;
    padding: 8px 0;
    text-align: center;
    color: white;
    border-radius: 30px;
    height: auto;
    font-size: 1rem;
    margin-left: 90px;
    text-indent: 0;
    font-size: 1.5rem;
    font-weight: bold;
    margin-top: 30px;
  }

  @media screen and (min-width: 768px) {
    #forget_outer .forget-body {
      padding-left: 5%;
      padding-right: 5%;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/ForgetPasswordPage.vue